import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// EN
import enCommon from "./locales/en/common.json";
import enRecruiting from "./locales/en/recruiting.json";
import enAdmin from "./locales/en/admin.json";
import enAuth from "./locales/en/auth.json";
import enPublic from "./locales/en/public.json";

// DE
import deCommon from "./locales/de/common.json";
import deRecruiting from "./locales/de/recruiting.json";
import deAdmin from "./locales/de/admin.json";
import deAuth from "./locales/de/auth.json";
import dePublic from "./locales/de/public.json";

// FR
import frCommon from "./locales/fr/common.json";
import frRecruiting from "./locales/fr/recruiting.json";
import frAdmin from "./locales/fr/admin.json";
import frAuth from "./locales/fr/auth.json";
import frPublic from "./locales/fr/public.json";

// PL
import plCommon from "./locales/pl/common.json";
import plRecruiting from "./locales/pl/recruiting.json";
import plAdmin from "./locales/pl/admin.json";
import plAuth from "./locales/pl/auth.json";
import plPublic from "./locales/pl/public.json";

// NL
import nlCommon from "./locales/nl/common.json";
import nlRecruiting from "./locales/nl/recruiting.json";
import nlAdmin from "./locales/nl/admin.json";
import nlAuth from "./locales/nl/auth.json";
import nlPublic from "./locales/nl/public.json";

// ES
import esCommon from "./locales/es/common.json";
import esRecruiting from "./locales/es/recruiting.json";
import esAdmin from "./locales/es/admin.json";
import esAuth from "./locales/es/auth.json";
import esPublic from "./locales/es/public.json";

export const SUPPORTED_LANGUAGES = [
  { code: "en", name: "English", nativeName: "English" },
  { code: "de", name: "German", nativeName: "Deutsch" },
  { code: "fr", name: "French", nativeName: "Français" },
  { code: "pl", name: "Polish", nativeName: "Polski" },
  { code: "nl", name: "Dutch", nativeName: "Nederlands" },
  { code: "es", name: "Spanish", nativeName: "Español" },
] as const;

export type SupportedLanguageCode =
  (typeof SUPPORTED_LANGUAGES)[number]["code"];

export const SUPPORTED_LANGUAGE_CODES: readonly SupportedLanguageCode[] =
  SUPPORTED_LANGUAGES.map((l) => l.code);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        recruiting: enRecruiting,
        admin: enAdmin,
        auth: enAuth,
        public: enPublic,
      },
      de: {
        common: deCommon,
        recruiting: deRecruiting,
        admin: deAdmin,
        auth: deAuth,
        public: dePublic,
      },
      fr: {
        common: frCommon,
        recruiting: frRecruiting,
        admin: frAdmin,
        auth: frAuth,
        public: frPublic,
      },
      pl: {
        common: plCommon,
        recruiting: plRecruiting,
        admin: plAdmin,
        auth: plAuth,
        public: plPublic,
      },
      nl: {
        common: nlCommon,
        recruiting: nlRecruiting,
        admin: nlAdmin,
        auth: nlAuth,
        public: nlPublic,
      },
      es: {
        common: esCommon,
        recruiting: esRecruiting,
        admin: esAdmin,
        auth: esAuth,
        public: esPublic,
      },
    },
    fallbackLng: "en",
    defaultNS: "common",
    ns: ["common", "recruiting", "admin", "auth", "public"],
    react: {
      useSuspense: false,
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
    saveMissing: process.env.NODE_ENV === "development",
    missingKeyHandler: (lngs, ns, key) => {
      if (process.env.NODE_ENV === "development") {
        console.warn(`[i18n] Missing key: ${ns}:${key} for [${lngs}]`);
      }
    },
  });

export default i18n;
